var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "organization-seats-site-license-type-table-cell" },
    [
      _setup.billingType === "SiteLicense"
        ? _c("span", [
            _c("span", { staticClass: "label-student-licenses" }, [
              _vm._v(
                "\n      Students: " +
                  _vm._s(_setup.usedStudentLicenses) +
                  " / " +
                  _vm._s(_setup.maxStudentLicenses) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label-instructor-licenses" }, [
              _vm._v(
                "\n      Instructors: " +
                  _vm._s(_setup.usedInstructorLicenses) +
                  " / " +
                  _vm._s(_setup.maxInstructorLicenses) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label-admin-licenses" }, [
              _vm._v(
                "\n      Admins: " +
                  _vm._s(_setup.usedAdminLicenses) +
                  " / " +
                  _vm._s(_setup.maxAdminLicenses) +
                  "\n    "
              ),
            ]),
          ])
        : _setup.billingType === "POT" || _setup.billingType === "BillMeLater"
        ? _c("span", [
            _c("span", { staticClass: "label-seats" }, [
              _vm._v(
                "\n      Seats: " +
                  _vm._s(_setup.usedSeats) +
                  "/" +
                  _vm._s(_setup.maxSeats) +
                  " (" +
                  _vm._s(_setup.maxSeats - _setup.usedSeats) +
                  "\n      available)\n    "
              ),
            ]),
          ])
        : _c("span", [_vm._v("N/A")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }